import { takeEvery, select, fork, put } from "redux-saga/effects";
import { setFlag } from "state/actions/ui";

function* handleNotification(action) {
    yield put(setFlag("console.notifications.open", true));
}

export default function* () {
    yield takeEvery("NOTIFICATIONS.CONSOLE.ADD", handleNotification);
}
